{
  "_hinweis": "Arten der Längen je Station (ANFORDERUNGEN.md C8). Erweiterbar als Datenliste, nicht im Code (PLAN.md, Abschnitt 4).",
  "arten": [
    { "schluessel": "kabelkanal", "name": "Kabelkanal", "einheit": "m" },
    { "schluessel": "rohr", "name": "Rohr", "einheit": "m" },
    { "schluessel": "kabel", "name": "Kabel", "einheit": "m" }
  ]
}
